export enum RadioStationsEnum {
  EXPRES = 'EXPRES',
  // CLASSIC = 'CLASSIC',
}

export enum AudioType {
  BACKGROUND_AUDIO = 'BG_AUDIO',
  GENERATED = 'GENERATED',
}

export enum TemplateType {
  PROMPT = 'PROMPT',
  PREDEFINED_TEXT = 'PREDEFINED_TEXT',
  SSML_TEMPLATE = 'SSML_TEMPLATE',
  SSML_TEMPLATE_DIALOGUE = 'SSML_TEMPLATE_DIALOGUE'
}

export enum AudioSourceType {
  TEXT = 'TEXT',
  SSML = 'SSML',
  DIALOGUE = 'DIALOGUE',
  PHONETIC = 'PHONETIC',
}

export enum PromethistStatus {
  PENDING = 'PENDING',
  CREATING_CONVERSATIONS = 'CREATING_CONVERSATIONS',
  FINISHED = 'FINISHED',
  TERMINATED = 'TERMINATED',
  TRANSCRIBING = 'TRANSCRIBING',
}
